import React, { Component } from 'react';
import Photos, { Files } from '../../../../commonModules/interface/input-files';
import InputText, { InputSelectNative, TextArea } from '../../../../commonModules/interface/form-input-inline.jsx';
import { isEmpty, size } from "lodash"
import PriceList from './PriceList';
import { Grid, TextField, Typography, Button, Box } from '@material-ui/core';
import { GroupCheckbox, GroupRadio, SingleCheckbox, SingleRadio, SingleSwitch } from '../../../../commonModules/MUI/RadioAndCheckbox';
import { toast } from 'react-toastify';
import StockageZone from './Stockage/StockageZone';

class FormProduct extends Component {
    state = {
        update: this.props.update,
        sending: false,
        photos:{},
        openPriceList: false,
        
        product: {
            name: "",
            id_supplier: "",
            hs_code: "",
            need_RFID: false,
            marque: "",
            product_type: "",
            reduc_max: 0,
            garantie: "",

            prix_venteHT :"",
            tva_rate : 0,
            prix_venteTTC: "",
            price_list: [],

            photos: [],
            datasheets: [],

            longueur:"",
            largeur:"",
            hauteur:"",
            poids:"",

            product_desc :"", // shop app
            product_title :"", // shop app

            pan_tensionVoc:"", 
            pan_courantIoc:"", 
            pan_tensionVmpp:"", 
            pan_courantImpp:"", 
            pan_puissance:"", 
            pan_cell:"", 
            pan_rendement:"",

            bat_type:"", 
            bat_tension:[], 
            bat_max_capacity:"", 
            bat_nb_cycles30:"",
            bat_nb_cycles50:"",
            bat_nb_cycles80:"",
            bat_rendement:"",
            bat_temperature:"",
            bat_auto_decharge:"",

            conv_tension:[],
            conv_puissance:"",
            conv_triphase:"",
            conv_puissance25:"",
            conv_puissance40:"",
            conv_puissance65:"",
            conv_puissance_crete:"",
            conv_eff_max:"",
            conv_signal:"",

            conv_absorption:"",
            conv_float:"",
            conv_courant_service:"",
            conv_courant_start:"",

            conv_tension_sortie:"",
            conv_sortie25:"",
            conv_sortie40:"",
            conv_tension_min:"",
            conv_tension_max:"",
            
            conv_MPPT_courant_sortie:"",
            conv_MPPT_tensionPV_max:"",
            conv_MPPT_puissancePV_max:"",

            reg_tension_max:"",
            reg_puissance_pv12:"",
            reg_puissance_pv24:"",
            reg_puissance_pv48:"",
            reg_type:"",
            reg_affichage:"",
            reg_courant:"",

            ond_tension_max: "",
            ond_courant_entree: "",
            ond_nb_mppt: "",
            ond_puissance_active: "",
            ond_puissance_apparente: "",
            ond_courant_sortie: "",
            ond_eff_max: "",
            ond_freq: "",
        
            plage_tension_mppt: "",
            plage_tension_ac: "",

            cab_type:"",
            cab_nb_conducteurs:"",
            cab_section:"",

            pomp_puissance:"",

            lam_puissance:"",
            lam_flux:"",
            lam_tension:"",

            men_type:"",
            men_infos:"",
            desc:"",
            tv_puissance_vide:"",
            tv_puissance_fonc:"",
            tv_taille:"",
            tv_tuner:"",
            tv_tension_alim: [],
            vent_puissance:"",

        },
        errors:{
            name: "",
            id_supplier: "",
            hs_code: "",
            marque: "",
            product_type: "",
            prix_venteTTC: "",
            reduc_max: "",
            garantie: "",
            prix_venteHT: "",
            pan_tensionVoc:"", 
            pan_courantIoc:"", 
            pan_tensionVmpp:"", 
            pan_courantImpp:"", 
            pan_puissance:"", 
            pan_cell:"", 
            pan_rendement:"",

            bat_type:"", 
            bat_tension:"", 
            bat_max_capacity:"", 
            bat_nb_cycles30:"",
            bat_nb_cycles50:"",
            bat_nb_cycles80:"",
            bat_rendement:"",
            bat_temperature:"",
            poids:"",
            bat_auto_decharge:"",

            conv_tension:"",
            conv_puissance:"",
            conv_triphase:"",
            conv_puissance25:"",
            conv_puissance40:"",
            conv_puissance65:"",
            conv_puissance_crete:"",
            conv_eff_max:"",
            conv_signal:"",

            conv_absorption:"",
            conv_float:"",
            conv_courant_service:"",
            conv_courant_start:"",

            conv_tension_sortie:"",
            conv_sortie25:"",
            conv_sortie40:"",
            conv_tension_min:"",
            conv_tension_max:"",

            conv_MPPT_courant_sortie:"",
            conv_MPPT_tensionPV_max:"",
            conv_MPPT_puissancePV_max:"",

            reg_tension_max:"",
            reg_puissance_pv12:"",
            reg_puissance_pv24:"",
            reg_puissance_pv48:"",
            reg_courant:"",
            reg_type:"",
            reg_affichage:"",

            ond_tension_max: "",
            ond_courant_entree: "",
            ond_nb_mppt: "",
            ond_puissance_active: "",
            ond_puissance_apparente: "",
            ond_courant_sortie: "",
            ond_eff_max: "",
            ond_freq: "",
        
            plage_tension_mppt: "",
            plage_tension_ac: "",

            cab_type:"",
            cab_nb_conducteurs:"",
            cab_section:"",
            
            pomp_puissance:"",

            lam_puissance:"",
            lam_flux:"",
            lam_tension:"",

            men_type:"",
            men_infos:"",
            desc:"",
            tv_puissance_vide:"",
            tv_puissance_fonc:"",
            tv_taille:"",
            tv_tuner:"",
            tv_tension_alim:"",
            vent_puissance:"",
        },

        floatFields: [
            "prix_venteTTC",
            "reduc_max",
            "prix_venteHT",
            "tva_rate",
            "poids",
            "bat_max_capacity",
            "pan_tensionVoc",
            "pan_courantIoc",
            "pan_tensionVmpp", 
            "pan_courantImpp",
            "pan_puissance",
            "pan_rendement",
            "bat_temperature",
            "bat_rendement",
            "bat_auto_decharge",
            "conv_puissance",
            "conv_puissance25",
            "conv_puissance40",
            "conv_puissance65",
            "conv_puissance_crete",
            "conv_eff_max",
            "conv_absorption",
            "conv_float",
            "conv_courant_service",
            "conv_courant_start",
            "conv_tension_sortie",
            "conv_sortie25",
            "conv_sortie40",
            "conv_tension_min",
            "conv_tension_max",
            "conv_MPPT_courant_sortie",
            "conv_MPPT_tensionPV_max",
            "conv_MPPT_puissancePV_max",
            "tv_taille",
            "tv_puissance_fonc",
            "tv_puissance_vide",
            "vent_puissance",
            "pomp_puissance",
            "lam_puissance",
            "lam_tension",
            "lam_flux",
            "cab_section",
            "reg_tension_max",
            "reg_puissance_pv12",
            "reg_puissance_pv24",
            "reg_puissance_pv48",
            "reg_courant",
            "ond_tension_max",
            "ond_courant_entree",
            "ond_nb_mppt",
            "ond_puissance_active",
            "ond_puissance_apparente",
            "ond_courant_sortie",
            "ond_eff_max",
            "ond_freq",
        ],
        intFields : [
            "longueur",
            "largeur",
            "hauteur",
            "garantie",
            "bat_nb_cycles",
            "bat_nb_cycles30",
            "bat_nb_cycles50",
            "bat_nb_cycles80",
        ],

    }

    componentDidMount = () => {
        const { product } = this.state;
        if(this.props.product){
            let newProd = Object.assign({}, product, this.props.product)
    
            console.log('====================================');
            console.log({product, newProd});
            console.log('====================================');
    
            this.setState({  product: newProd})
        }
    }
    createTypeList(){ 
        const types = {
            "panneaux":"Panneaux Solaires",
            "regulateurs":"Régulateurs",
            "convertisseurs":"Convertisseurs",
            "convertisseurs_chargeurs":"Convertisseur-Chargeurs",
            "convertisseurs_chargeurs_MPPT":"Convertisseur-Chargeurs - MPPT",
            "convertisseurs_dc-dc":"Convertisseur DC-DC",
            "onduleurs":"Onduleurs",
            "batteries":"Batteries",
            "cables":"Câbles",
            "lampes":"Lampes",
            "supervision":"Supervision",
            "kit":"Kits complet",
            "menager":"Equipement ménager",
            "pompes":"Pompes",
            "picos":"Picos",
            "accesoires":"Accessoires",
            "protection":"Protection",
            "autres":"Autres",
            "equipement_bt":"Equipement BT"
        }
        // return Object.keys(types).map((key) => (        
        //     {value: key, label:types[key] }
        // ))
        return Object.keys(types).map((key) => {
            return (        
                <option key={key} value={key} >{types[key]}</option>
            )
        })
    }

    handleChange = (e) => { 
        const field = e.target.name
        const value = e.target.value
        const regex = /^[+]?([0-9]*(\.[0-9]*)?)$/ // numbers (int & float) only
        const regex2 = /^[0-9\b]+$/ // int only
        const {floatFields, intFields} = this.state
        const noUpdate = [
            "type",
            "marque",
            "men_type",
        ]
        console.log({e, field, value});

        if(floatFields.includes(field)){
            if( value === "" || regex.test(value) ){// update value only if its a int || float
                    if(field === "tva_rate") {
                    let TTC = this.state.product.prix_venteHT * (((value || 0) / 100 ) + 1)
                    this.setState({
                        ...this.state,
                        product:{
                            ...this.state.product,
                            prix_venteTTC: TTC,
                            [field]:value
                        }
                    })
                } else if(field === "prix_venteHT"){
                    let TTC = (value || 0) * (((this.state.product.tva_rate || 0) / 100 ) + 1)
                    this.setState({
                        ...this.state,
                        product:{
                            ...this.state.product,
                            prix_venteTTC: TTC,
                            [field]:value
                        }
                    })
                } else {
                    this.setState({
                        ...this.state,
                        product:{
                            ...this.state.product,
                            [field]:value
                        }
                    })

                }

            }
        } else if( intFields.includes(field)){
            if(value ==="" || regex2.test(value)){// update value only if its an int
                this.setState({
                    ...this.state,
                    product:{
                        ...this.state.product,
                        [field]:value
                    }
                })
            }
        } else if(this.state.update && noUpdate.includes(field)){
            this.setState({// don't change on update 
                ...this.state,
                product:{
                    ...this.state.product
                }
            })
        } else {
            this.setState({
                ...this.state,
                product:{
                    ...this.state.product,
                    [field]:e.target.value
                }
            })

        }
    }
    handleChangeRadio = (e, name) => {
        this.setState({
            ...this.state,
            product:{
                ...this.state.product,
                [name]:e.target.value
            }
        })
    }
    handleChangeRadioSwitch = (e, name) => {
        console.log("handleChangeRadioSwitch,",e,"-",name)
        this.setState({
            ...this.state,
            product:{
                ...this.state.product,
                [name]:e
            }
        })
    }
    setCheckbox = ( e, name ) => {
        let value = parseInt(e.target.value);
        console.log({value, name});

        const tmpActions = this.state.product[name];
        console.log(this.state.product, tmpActions);
        const idx = tmpActions.indexOf(value);
        console.log('BEFORE ADD/DELETE : ', tmpActions, idx);
        

        if (idx !== -1) {
            tmpActions.splice(idx, 1);
        } else {
            tmpActions.push(value);
        }

        console.log('AFTER ADD/DELETE : ', tmpActions);
        this.setState({ 
            ...this.state,
            product:{
                ...this.state.product,
                [name]: tmpActions 
            }
        });
    }
    setPhotos = (list) => {
        console.log("[INFO] SETPHOTOS", list);
        
        this.setState({
            ...this.state,
            product:{
                ...this.state.product,
                photos:list
            }
        })
    }
    setFiles = (list) => {
        console.log("[INFO] SET FILES", list);
        
        this.setState({
            ...this.state,
            product:{
                ...this.state.product,
                datasheets:list
            }
        })
    }

    savePriceList = (price_list, prix_venteHT_pro) => {
        console.log('=============== savePriceList ====================');
        console.log({price_list, prix_venteHT_pro});
        console.log('====================================');
        this.setState({
            product: {
                ...this.state.product,
                prix_venteHT_pro,
                price_list
            },
        })
        toast.warning("Grille de prix enregistrée")
        this.handleClosePriceList()
    }
    handleClosePriceList = () => {
        this.setState({
            openPriceList: false,
        })
    }
    createRef(){
        const {PRODUCTS} = this.props
        let { marque, product_type } = this.state.product
        // ref = product_type_marque_id ex: PAN_VIC_1R77YB8
        marque = marque.normalize('NFD').replace(/[\u0300-\u036f]/g, "") // remove accents

        let ref = (product_type).substr(0,3) + "_" + (marque).substr(0,3)
        ref = ref.toUpperCase()
        console.log("[INFO] createRef " ,ref)

        if(!isEmpty){
            Object.values(PRODUCTS).map( product => {// checks if ref of product is used already
                if(product.ref === ref){// if exist
                    ref = this.createRef() // create new one
                }
            })
        }
        return ref
    }
    validate = () => {//check form data before submit
        let noErrors = true
        let errors = {}

        const common = [
            "name",
            "marque",
            "product_type",
            "prix_venteHT",
            // "tva_rate",
            "prix_venteTTC",
            "garantie",
            "poids",
            "longueur",
            "largeur",
            "hauteur", 
        ]

        // REQUIRED FIELD BY TYPE
            const panels = [
                "pan_tensionVoc",
                "pan_courantIoc",
                "pan_tensionVmpp", 
                "pan_courantImpp", 
                "pan_puissance", 
                "pan_cell", 
                "pan_rendement",
            ]
            const bat = [
                "bat_type", 
                "bat_tension", 
                "bat_max_capacity", 
                "bat_nb_cycles",
                // "bat_nb_cycles30",
                // "bat_nb_cycles50",
                // "bat_nb_cycles80", seulement pour les prod victron
                "bat_rendement",
                "bat_temperature",
                "bat_auto_decharge",
            ]
            const conv = [
                "conv_tension",
                "conv_puissance",
                "conv_triphase",
                "conv_puissance_crete",
                "conv_eff_max",
                "conv_signal",
            ]
            const conv_ch =[
                "conv_absorption",
                "conv_float",
                "conv_courant_service",
                "conv_courant_start",
            ]
            const conv_MPPT =[
                "conv_MPPT_courant_sortie",
                "conv_MPPT_tensionPV_max",
                "conv_MPPT_puissancePV_max",
            ]
            const cdc=[
                "conv_tension_sortie",
                "conv_sortie25",
                "conv_sortie40",
                "conv_tension_min",
                "conv_tension_max",
                "conv_eff_max",
            ]
            const reg = [
                "reg_tension_max",
                "reg_puissance_pv12",
                "reg_puissance_pv24",
                "reg_puissance_pv48", // not required
                "reg_courant",
                "reg_type",
                "reg_affichage",
                "bat_tension", 
            ]
            const ond = [
                "ond_tension_max",
                "ond_courant_entree",
                "ond_nb_mppt",

                "ond_puissance_active",
                "ond_puissance_apparente",
                "ond_courant_sortie",
                "ond_eff_max",
                "ond_freq",
                "plage_tension_mppt",
                "plage_tension_ac",
    
            ]
            const cab = [
                "cab_type",
                "cab_nb_conducteurs",
                "cab_section",
            ]
            const lam = [
                "lam_puissance",
                "lam_flux",
                "lam_tension",
            ]
            const menager = [
                "men_type"
            ]
            
            const pompes = [
                "pomp_puissance"
            ]
            

        Object.keys(this.state.product).map( field => {
            if(this.state.product[field] === "" || this.state.product[field] === []){// input is empty  
                if(this.state.product.product_type === "panneaux" && panels.includes(field) ){// check pannel desc fields
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"

                } else if (this.state.product.product_type === "convertisseurs" && conv.includes(field)) {
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"

                } else if (this.state.product.product_type === "convertisseurs_chargeurs" && (conv.includes(field) || conv_ch.includes(field) ) ) {
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"
                } else if (this.state.product.product_type === "convertisseurs_chargeurs_MPPT" && (conv.includes(field) || conv_MPPT.includes(field) ) ) {
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"

                } else if (this.state.product.product_type === "convertisseurs_dc-dc" && cdc.includes(field) ) {
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"

                } else if (this.state.product.product_type === "regulateurs" && reg.includes(field) ) {
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"

                } else if (this.state.product.product_type === "onduleurs" && ond.includes(field) ) {
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"

                } else if (this.state.product.product_type === "cables" && cab.includes(field) ) {
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"

                } else if (this.state.product.product_type === "batteries" && bat.includes(field)) {
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"

                } else if (this.state.product.product_type === "lampes" && lam.includes(field)) {
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"

                } else if (this.state.product.product_type === "menager" &&  menager.includes(field) ) {// common fields
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"
                } else if (this.state.product.product_type === "pompes" &&  pompes.includes(field) ) {// common fields
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"

                } else if ( common.includes(field) ) {// common fields
                    noErrors = false
                    errors[field] = "Veuillez remplir ce champ"

                } else {// no error
                    errors[field] = ""   
                }
            } else if(field === "name"){
                const {PRODUCTS} = this.props
                if(Object.keys(PRODUCTS).length > 0){

                    Object.keys(PRODUCTS).map((ID)=>{// checks if name of product is used already
                        if( ((this.state.product.name).toLowerCase() === (PRODUCTS[ID].name).toLowerCase()) && ID !== this.state.product.id ){
                            noErrors = false
                            errors[field] = "Ce nom de produit existe déja" 
                        }
                    })
                }
            } else {// no error
                errors[field] = ""   
            }
        })
        
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        })
        return noErrors
    }

    handleSubmit = async () => {
        if( this.validate()){
            const newProd = Object.assign({},this.state.product)
            newProd.id = ""

            const { floatFields, intFields } = this.state

            floatFields.map( field => {
                newProd[field] = parseFloat(newProd[field])
            })
            intFields.map( field => {
                newProd[field] = parseInt(newProd[field])
            })

            newProd.ref = this.createRef()
                
            console.log(newProd);
                
            await this.props.createProduct(newProd)
                
            if(this.props.STATE.products.error){
                console.log("ERROR", this.props.STATE.products.error);
                this.setState({
                    sending: false,
                })
                toast.error( this.props.STATE.products.error)
            } else{
                console.log("fetched");
                //success 
                this.setState({
                    sending: false,
                })
                toast.info("Le produit a été créé avec succès")
                // this.clearForms()
                this.props.getPhotoProd(Object.keys(this.props.PRODUCTS)[0]) // get photo of last created product
                this.props.handleClose()
            }
        } else {
            toast.error( "Le formulaire contient des erreurs")
            this.setState({
                sending: false,
            })
        }
    }
    handleSubmitUpdate = async () => {
        if( this.validate()){
            const newProd = Object.assign({},this.props.product, this.state.product)
            const {floatFields, intFields} = this.state
            
            floatFields.map( field => {
                newProd[field] = parseFloat(newProd[field])                
            })
            intFields.map( field => {
                newProd[field] = parseInt(newProd[field])
            })
            if (this.props.duplicate) {
                newProd.account_id = this.props.match_dest_account
            }
            
            try {
            await this.props.updateProduct(newProd)

            if(this.props.STATE.products.error){
                console.log("ERROR", this.props.STATE.products.error);
                    const errorMessage = this.props.STATE.products.error;
                    toast.error(errorMessage);
                    
                    // Call onError prop if provided (for parent components to handle errors)
                    if (this.props.onError) {
                        this.props.onError(errorMessage);
                    }
            } else{
                console.log("Product updated")
                //success 
                if (this.props.duplicate) {
                    toast.info("Le produit a été dupliqué avec succès")
                } else {
                    toast.info("Le produit a été modifié avec succès")
                }
                // this.clearForms()
                // Use handleCloseForm if available, otherwise fall back to handleClose
                if (this.props.handleCloseForm) {
                    this.props.handleCloseForm()
                } else if (this.props.handleClose) {
                    this.props.handleClose()
                }
                }
            } catch (error) {
                console.error("Update product error:", error);
                const errorMessage = error.message || "Une erreur est survenue lors de la mise à jour";
                toast.error(errorMessage);
                
                // Call onError prop if provided
                if (this.props.onError) {
                    this.props.onError(errorMessage);
                }
            }

        } else {
            toast.warning( "le formulaire contient des erreurs" )
        }
    }
    render() {
        const {openPriceList} = this.state;
        const prodForm = (
            <Box p={1}>
                <InputText 
                    name="name" 
                    value={this.state.product.name} 
                    error={this.state.errors.name} 
                    change={this.handleChange} 
                    title="Nom" 
                    placeholder="Nom du Produit" 
                    required
                />

                <InputText 
                    name="id_supplier" 
                    value={this.state.product.id_supplier} 
                    error={this.state.errors.id_supplier} 
                    change={this.handleChange} 
                    title="ID fournisseur" 
                    placeholder="Référence Produit chez le fournisseur" 
                />
                <InputText 
                    name="hs_code" 
                    value={this.state.product.hs_code} 
                    error={this.state.errors.hs_code} 
                    change={this.handleChange} 
                    title="HS Code" 
                />
                <InputText 
                    name="product_title" 
                    value={this.state.product.product_title} 
                    error={this.state.errors.product_title} 
                    change={this.handleChange} 
                    title="Titre" 
                    placeholder="Titre du Produit" 
                />
                <SingleSwitch 
                    label="Ce produit nécessite une étiquette RFID"
                    checked={this.state.product.need_RFID}
                    color="primary"
                    labelPlacement="start"
                    name="need_RFID" 
                    onChange={
                        (e) => this.handleChangeRadioSwitch(e.target.checked, "need_RFID")
                    }
                />
                
                {/* <div className={"form-group "+ (this.state.errors.product_type ? "has-error" : "")}>
                    <label htmlFor="type" className="col-sm-3 control-label">Type de Produit *</label>
                    <div className="col-sm-9">
                        <div className="fg-line select">      
                            <select disabled={this.state.update} onChange={this.handleChange} value={this.state.product.product_type} name="type" className="form-control input-sm selectpicker bs-select-hidden">
                                <option value="">Choisissez</option>
                                {this.createTypeList()}
                            </select>
                            <small className="help-block">{this.state.errors.product_type}</small>
                        </div>
                    </div>
                </div> */}
                <InputSelectNative
                    label="Type de Produit"
                    name="product_type"
                    value={this.state.product.product_type}
                    error={this.state.errors.product_type}
                    change={this.handleChange}
                    required
                    options={this.createTypeList()}
                />
                 
                {!this.state.update &&
                <Box p={1} >
                    <label className="control-label">Photos </label>
                    <div >
                        <Photos photoList={this.setPhotos} photos={this.state.product.photos === null ? [] : this.state.product.photos }/>
                    </div>
                </Box>
                }
                {!this.state.update &&
                <Box p={1 }>
                    <label className="control-label">Autres Fichiers </label>
                    <div>
                        <Files photoList={this.setFiles} photos={this.state.product.datasheets === null ? [] : this.state.product.datasheets } file />
                    </div>
                </Box>
                }

                <InputText 
                    disabled={this.state.update} 
                    name="marque" 
                    value={this.state.product.marque} 
                    error={this.state.errors.marque} 
                    change={this.handleChange} 
                    title="Marque" 
                    required
                    placeholder="Marque du Produit" 
                />
                <TextArea 
                    name="product_desc" 
                    value={this.state.product.product_desc} 
                    error={this.state.errors.product_desc} 
                    change={this.handleChange} 
                    title="Description Détaillée" 
                    required
                    rows={5}
                    placeholder="Description du Produit" 
                />

                {/* <div className={"form-group "+ (this.state.errors.product_desc ? "has-error" : "")}>
                    <label htmlFor="product_desc" className="col-sm-3 control-label">Description</label>
                    <div className="col-sm-9">
                        <textarea className="form-control" id="product_desc" onChange={this.handleChange} value={this.state.product.product_desc} name="product_desc" rows="5" placeholder="Description du Produit"></textarea>
                        <small className="help-block">{this.state.errors.product_desc}</small>
                    </div>
                </div> */}

                <InputText type="number" inputProps={{inputMode: 'numeric',pattern: '[0-9]*',}} required name="garantie" value={this.state.product.garantie} error={this.state.errors.garantie} change={this.handleChange} title="Garantie (Années) " placeholder="Garantie en années" />
                        
                {this.state.product.product_type === "panneaux" &&
                <div>
                    <InputText name="pan_puissance" value={this.state.product.pan_puissance} error={this.state.errors.pan_puissance} change={this.handleChange} title="Puissance (W)" required />

                    <InputText name="pan_courantIoc" value={this.state.product.pan_courantIoc} error={this.state.errors.pan_courantIoc} change={this.handleChange} title="Courant (Ioc)" required />

                    <InputText name="pan_tensionVoc" value={this.state.product.pan_tensionVoc} error={this.state.errors.pan_tensionVoc} change={this.handleChange} title="Tension (Voc)" required />

                    <InputText name="pan_courantImpp" value={this.state.product.pan_courantImpp} error={this.state.errors.pan_courantImpp} change={this.handleChange} title="Courant (Impp)" required />

                    <InputText name="pan_tensionVmpp" value={this.state.product.pan_tensionVmpp} error={this.state.errors.pan_tensionVmpp} change={this.handleChange} title="Tension (Vmpp)" required />

                    <InputText name="pan_rendement" value={this.state.product.pan_rendement} error={this.state.errors.pan_rendement} change={this.handleChange} title="Rendement (%)" required />
                                                    
                    {/* <div className={"form-group "+ (this.state.errors.pan_cell ? "has-error" : "")}>
                        <label htmlFor="pan_cell" className="col-sm-3 control-label">Cellules *</label>
                        <div className="col-sm-9">
                            <div className="fg-line select">      
                                <select id="pan_cell" onChange={this.handleChange} value={this.state.product.pan_cell} name="pan_cell" className="form-control input-sm selectpicker bs-select-hidden">
                                    <option value="">Choisissez</option>
                                    <option value="polycristalline">Polycristalline</option>
                                    <option value="monocristalline">Monocristalline</option>
                                </select>
                                <small className="help-block">{this.state.errors.pan_cell}</small>
                            </div>
                        </div>
                    </div>                                   */}
                    <InputSelectNative
                        label="Type de Produit"
                        name="pan_cell"
                        value={this.state.product.pan_cell}
                        error={this.state.errors.pan_cell}
                        change={this.handleChange}
                        required
                        options={[<option value="polycristalline">Polycristalline</option>,
                        <option value="monocristalline">Monocristalline</option>]}
                    />
                </div>
                }
                {(this.state.product.product_type).startsWith("convertisseurs") &&
                <div>
                    {this.state.product.product_type !== "convertisseurs_dc-dc" &&
                    <div>
                        <GroupCheckbox label="Tension Entrée" required error={this.state.errors.conv_tension}>
                            <SingleCheckbox label="12V" value={12} checked={this.state.product.conv_tension && this.state.product.conv_tension.includes(12)} onChange={(e) => this.setCheckbox(e, "conv_tension")} />
                            <SingleCheckbox label="24V" value={24} checked={this.state.product.conv_tension && this.state.product.conv_tension.includes(24)} onChange={(e) => this.setCheckbox(e, "conv_tension")} />
                            <SingleCheckbox label="48V" value={48} checked={this.state.product.conv_tension && this.state.product.conv_tension.includes(48)} onChange={(e) => this.setCheckbox(e, "conv_tension")} />
                        </GroupCheckbox>
                        <InputSelectNative
                            label="Type Signal"
                            name="conv_signal"
                            value={this.state.product.conv_signal}
                            error={this.state.errors.conv_signal}
                            change={this.handleChange}
                            required
                            options={[<option value="Sinus Pur">Sinus pur</option>,
                            <option value="Quasi Sinus">Quasi sinus</option>]}
                        />
                        <InputText name="conv_puissance" value={this.state.product.conv_puissance} error={this.state.errors.conv_puissance} change={this.handleChange} title="Puissance Sortie (VA) " required />
                        <InputText name="conv_puissance25" value={this.state.product.conv_puissance25} error={this.state.errors.conv_puissance25} change={this.handleChange} title="Puissance à 25°C (W)" />
                        <InputText name="conv_puissance40" value={this.state.product.conv_puissance40} error={this.state.errors.conv_puissance40} change={this.handleChange} title="Puissance à 40°C (W)" />
                        <InputText name="conv_puissance65" value={this.state.product.conv_puissance65} error={this.state.errors.conv_puissance65} change={this.handleChange} title="Puissance à 65°C (W)" />
                        <InputText name="conv_puissance_crete" value={this.state.product.conv_puissance_crete} error={this.state.errors.conv_puissance_crete} change={this.handleChange} title="Puissance Crete (W) " required />                            
                                                      
                        <GroupRadio
                            name="conv_triphase"
                            label="Triphasé ?"
                            onChange={(e) => this.handleChangeRadio(e, "conv_triphase")}
                            value={this.state.product.conv_triphase}
                            required
                            error={this.state.errors.conv_triphase}
                        >
                            <SingleRadio name="conv_triphase" value="oui" label="Oui" />
                            <SingleRadio name="conv_triphase" value="non" label="Non" />
                        </GroupRadio>
                    </div>
                    }
                    <InputText name="conv_eff_max" value={this.state.product.conv_eff_max} error={this.state.errors.conv_eff_max} change={this.handleChange} title="Efficacité maximale (%) " required />

                </div>
                }
                {this.state.product.product_type === "convertisseurs_chargeurs" && 
                <div>
                    <InputText title="Tension de charge 'Absorption' " required change={this.handleChange} value={this.state.product.conv_absorption} name="conv_absorption" placeholder="Tension de charge 'Absorption' (VCC)" error={this.state.errors.conv_absorption} />
                            
                    <InputText title="Tension de charge 'Float' " required change={this.handleChange} value={this.state.product.conv_float} name="conv_float" placeholder="Tension de charge 'Float' (VCC)" error={this.state.errors.conv_float}/>
                            
                    <InputText title="Courant de Charge de batterie de service " required change={this.handleChange} value={this.state.product.conv_courant_service} name="conv_courant_service" placeholder="Courant de Charge de batterie de service (A)" error={this.state.errors.conv_courant_service} />
                            
                    <InputText title="Courant de Charge de batterie démarrage " required change={this.handleChange} value={this.state.product.conv_courant_start} name="conv_courant_start" placeholder="Courant de Charge de batterie démarrage (A)" error={this.state.errors.conv_courant_start} />
                </div>
                               
                }
                {this.state.product.product_type === "convertisseurs_chargeurs_MPPT" && 
                <div>
                    <InputText title="Courant de Sortie Max " required change={this.handleChange} value={this.state.product.conv_MPPT_courant_sortie} name="conv_MPPT_courant_sortie" placeholder="Courant de Sortie Max" error={this.state.errors.conv_MPPT_courant_sortie} />
                            
                    <InputText title="Tension PV Max " required change={this.handleChange} value={this.state.product.conv_MPPT_tensionPV_max} name="conv_MPPT_tensionPV_max" placeholder="Tension PV Max" error={this.state.errors.conv_MPPT_tensionPV_max}/>
                            
                    <InputText title="Puissance PV Max " required change={this.handleChange} value={this.state.product.conv_MPPT_puissancePV_max} name="conv_MPPT_puissancePV_max" placeholder="Puissance PV Max" error={this.state.errors.conv_MPPT_puissancePV_max} />                    
                </div>
                }
                               
                {this.state.product.product_type === "convertisseurs_dc-dc" &&
                <div>
                    <InputText title="Courant de Charge de batterie démarrage " required change={this.handleChange} value={this.state.product.conv_courant_start} name="conv_courant_start" placeholder="Courant de Charge de batterie démarrage (A)" error={this.state.errors.conv_courant_start} />

                    <InputText change={this.handleChange} value={this.state.product.conv_sortie25} name="conv_sortie25" title="Puissance sortie continue à 25°C (W) " required error={this.state.errors.conv_sortie25}/>
                    
                    <InputText change={this.handleChange} value={this.state.product.conv_sortie40} name="conv_sortie40" title="Puissance sortie continue à 40° C (W) " required error={this.state.errors.conv_sortie40} />
                    
                    <InputText change={this.handleChange} value={this.state.product.conv_tension_sortie} name="conv_tension_sortie" title="Tension de sortie nominale (VDC) " required error={this.state.errors.conv_tension_sortie} />
                    
                    <InputText change={this.handleChange} value={this.state.product.conv_tension_min} name="conv_tension_min" title="Tension entrée minimale (VDC) " required error={this.state.errors.conv_tension_min} />
                    
                    <InputText change={this.handleChange} value={this.state.product.conv_tension_max} name="conv_tension_max" title="Tension entrée maximale (VDC) " required error={this.state.errors.conv_tension_max} />
                            
                </div>
                }
                {this.state.product.product_type === "batteries" &&
                <div>
                    <InputSelectNative
                        label="Type Batterie"
                        name="bat_type"
                        value={this.state.product.bat_type}
                        error={this.state.errors.bat_type}
                        change={this.handleChange}
                        required
                        options={[<option value="carbone">Carbone</option>,
                        <option value="GEL">GEL</option>,
                        <option value="lithium">Lithium</option>,
                        <option value="acide">Acide</option>,
                        <option value="AGM">AGM</option>]}
                    />
                    <GroupCheckbox name="bat_tension" label="Tension" required error={this.state.errors.bat_tension}>
                        <SingleCheckbox label="2V" value={2} checked={this.state.product.bat_tension && this.state.product.bat_tension.includes(2)} onChange={(e) => this.setCheckbox(e, "bat_tension")} />
                        <SingleCheckbox label="6V" value={6} checked={this.state.product.bat_tension && this.state.product.bat_tension.includes(6)} onChange={(e) => this.setCheckbox(e, "bat_tension")} />
                        <SingleCheckbox label="12V" value={12} checked={this.state.product.bat_tension && this.state.product.bat_tension.includes(12)} onChange={(e) => this.setCheckbox(e, "bat_tension")} />
                        <SingleCheckbox label="48V" value={48} checked={this.state.product.bat_tension && this.state.product.bat_tension.includes(48)} onChange={(e) => this.setCheckbox(e, "bat_tension")} />
                    </GroupCheckbox>
                    
                    <InputText change={this.handleChange} value={this.state.product.bat_max_capacity} name="bat_max_capacity" title="Capacité Max (Ah) " required error={this.state.errors.bat_max_capacity}    />              
                                                                                
                    <InputText change={this.handleChange} value={this.state.product.bat_nb_cycles30} name="bat_nb_cycles30" title="Nombre de Cycles à  30% de DOD" error={this.state.errors.bat_nb_cycles30} />
            
                    <InputText change={this.handleChange} value={this.state.product.bat_nb_cycles50} name="bat_nb_cycles50" title="Nombre de Cycles à  50% de DOD" error={this.state.errors.bat_nb_cycles50} />
            
                    <InputText change={this.handleChange} value={this.state.product.bat_nb_cycles80} name="bat_nb_cycles80" title="Nombre de Cycles à  80% de DOD" error={this.state.errors.bat_nb_cycles80} />

                    <InputText change={this.handleChange} value={this.state.product.bat_auto_decharge} name="bat_auto_decharge" title="Auto décharge " required error={this.state.errors.bat_auto_decharge} />
                
                    <InputText change={this.handleChange} value={this.state.product.bat_rendement} name="bat_rendement" title="Rendement Energétique " required error={this.state.errors.bat_rendement} />
                                                    
                    <InputText change={this.handleChange} value={this.state.product.bat_temperature} name="bat_temperature" title="Température d'exploitation (°C) " required error={this.state.errors.bat_temperature} />
                                                        
                </div>
                }
                {this.state.product.product_type === "regulateurs" &&
                <div>
                     <InputSelectNative
                        label="Type Regulateur"
                        name="reg_type"
                        value={this.state.product.reg_type}
                        error={this.state.errors.reg_type}
                        change={this.handleChange}
                        required
                        options={[<option value="MPPT">MPPT</option>,
                        <option value="PWM">PWM</option>]}
                    />
                    <InputSelectNative
                        label="Affichage"
                        name="reg_affichage"
                        value={this.state.product.reg_affichage}
                        error={this.state.errors.reg_affichage}
                        change={this.handleChange}
                        required
                        options={[<option value="numerique">Numérique</option>,
                        <option value="led">LED</option>]}
                    />
                    <GroupCheckbox name="bat_tension" label="Tension" required error={this.state.errors.bat_tension}>
                        <SingleCheckbox label="12V" value={12} checked={this.state.product.bat_tension && this.state.product.bat_tension.includes(12)} onChange={(e) => this.setCheckbox(e, "bat_tension")} />
                        <SingleCheckbox label="24V" value={24} checked={this.state.product.bat_tension && this.state.product.bat_tension.includes(24)} onChange={(e) => this.setCheckbox(e, "bat_tension")} />
                        <SingleCheckbox label="48V" value={48} checked={this.state.product.bat_tension && this.state.product.bat_tension.includes(48)} onChange={(e) => this.setCheckbox(e, "bat_tension")} />
                    </GroupCheckbox>

                    <InputText change={this.handleChange} value={this.state.product.reg_tension_max} name="reg_tension_max" title="Tension Maximale en circuit ouvert " required error={this.state.errors.reg_tension_max} />

                    <InputText change={this.handleChange} value={this.state.product.reg_puissance_pv12} name="reg_puissance_pv12" title="Puissance nominale 12V " required error={this.state.errors.reg_puissance_pv12} />

                    <InputText change={this.handleChange} value={this.state.product.reg_puissance_pv24} name="reg_puissance_pv24" title="Puissance nominale 24V " required error={this.state.errors.reg_puissance_pv24} />

                    <InputText change={this.handleChange} value={this.state.product.reg_puissance_pv48} name="reg_puissance_pv48" title="Puissance nominale 48V " required error={this.state.errors.reg_puissance_pv48} />

                    <InputText change={this.handleChange} value={this.state.product.reg_courant} name="reg_courant" title="Courant de charge nominal " required error={this.state.errors.reg_courant} />

                </div>
                }
                {this.state.product.product_type === "onduleurs" &&
                <div>                    
                    <InputText change={this.handleChange} value={this.state.product.ond_tension_max} name="ond_tension_max" title="Tension d'entrée maximale (V) " required error={this.state.errors.ond_tension_max} />

                    <InputText change={this.handleChange} value={this.state.product.ond_courant_entree} name="ond_courant_entree" title="Courant d'entrée maximal (A) " required error={this.state.errors.ond_courant_entree} />

                    <InputText change={this.handleChange} value={this.state.product.ond_nb_mppt} name="ond_nb_mppt" title="Nombre de MPPT " required error={this.state.errors.ond_nb_mppt} />

                    <InputText change={this.handleChange} value={this.state.product.ond_puissance_active} name="ond_puissance_active" title="Puissance active CA (W) " required error={this.state.errors.ond_puissance_active} />

                    <InputText change={this.handleChange} value={this.state.product.ond_puissance_apparente} name="ond_puissance_apparente" title="Puissance apparente maximale (VA) " required error={this.state.errors.ond_puissance_apparente} />
                    
                    <InputText change={this.handleChange} value={this.state.product.ond_courant_sortie} name="ond_courant_sortie" title="Courant de sortie Maximal (A) " required error={this.state.errors.ond_courant_sortie} />

                    <InputText change={this.handleChange} value={this.state.product.ond_eff_max} name="ond_eff_max" title="Efficacité maximale (%) " required error={this.state.errors.ond_eff_max} />

                    <InputText change={this.handleChange} value={this.state.product.ond_freq} name="ond_freq" title="Fréquence nominale du réseau (Hz) " required error={this.state.errors.ond_freq} />

                    <InputText change={this.handleChange} value={this.state.product.plage_tension_mppt} name="plage_tension_mppt" title="Plage de Tension en fonctionnement MPPT (V) " required error={this.state.errors.plage_tension_mppt} />

                    <InputText change={this.handleChange} value={this.state.product.plage_tension_ac} name="plage_tension_ac" title="Plage de Tension AC (V) " required error={this.state.errors.plage_tension_ac} />

                </div>
                }
                {this.state.product.product_type === "cables" &&
                <div>
                    <InputSelectNative
                        label="Type de Conduits"
                        name="cab_type"
                        value={this.state.product.cab_type}
                        error={this.state.errors.cab_type}
                        change={this.handleChange}
                        required
                        options={[<option value="rigide">Rigide</option>,
                        <option value="souple">Souple</option>]}
                    />
                    <InputSelectNative
                        label="Nombre de conducteurs"
                        name="cab_nb_conducteurs"
                        value={this.state.product.cab_nb_conducteurs}
                        error={this.state.errors.cab_nb_conducteurs}
                        change={this.handleChange}
                        required
                        options={[
                            <option value={1}>1 fil</option>,
                            <option value={2}>2 fils</option>,
                            <option value={3}>3 fils</option>,
                            <option value={4}>4 fils</option>
                        ]}
                    />
                    <InputText  change={this.handleChange} value={this.state.product.cab_section} name="cab_section" title="Section des conducteurs (mm2) " required error={this.state.errors.cab_section}/>
                </div>
                }

                {this.state.product.product_type === "pompes" &&
                    <InputText  change={this.handleChange} value={this.state.product.pomp_puissance} name="pomp_puissance" title="Puissance (W) " required error={this.state.errors.pomp_puissance}/>
                }
                {this.state.product.product_type === "lampes" &&
                <div>
                    <InputText  change={this.handleChange} value={this.state.product.lam_puissance} name="lam_puissance" title="Puissance (W) " required error={this.state.errors.lam_puissance}/>

                    <InputText  change={this.handleChange} value={this.state.product.lam_flux} name="lam_flux" title="Flux lumineux (lm) " required error={this.state.errors.lam_flux} />

                    <InputSelectNative
                        label="Tension d'alimentation"
                        name="lam_tension"
                        value={this.state.product.lam_tension}
                        error={this.state.errors.lam_tension}
                        change={this.handleChange}
                        required
                        options={[
                            <option value={12}>12V</option>,
                            <option value={220}>220V</option>
                        ]}
                    />
                </div>
                }
                {this.state.product.product_type === "menager" &&
                <div>
                    <InputSelectNative
                        label="Type"
                        name="men_type"
                        value={this.state.product.men_type}
                        error={this.state.errors.men_type}
                        change={this.handleChange}
                        required
                        options={[
                            <option value="TV">Télévision</option>,
                            <option value="Ventilateur">Ventilateur</option>,
                            <option value="Autre">Autre</option>
                        ]}
                    />
                    {this.state.product.men_type === "TV" &&
                    <div>
                        <InputText change={this.handleChange} value={this.state.product.tv_taille} name="tv_taille" title="Taille (pouce) " required error={this.state.errors.tv_taille}/>
                        
                        <InputText  change={this.handleChange} value={this.state.product.tv_puissance_vide} name="tv_puissance_vide" title="Puissance à vide(W) " required error={this.state.errors.tv_puissance_vide}/>
                        <InputText  change={this.handleChange} value={this.state.product.tv_puissance_fonc} name="tv_puissance_fonc" title="Puissance en fonctionnement (W) " required error={this.state.errors.tv_puissance_fonc}/>

                        <div className={"form-group "+ (this.state.errors.tv_tuner ? "has-error" : "")}>
                            <label className="col-sm-3 control-label">Tuner inclus *</label>
                            <div className="col-sm-9">
                                <label htmlFor="tv_tunerT" className="radio radio-inline m-r-20">
                                    <input name="tv_tuner" id="tv_tunerT" type="radio" value={this.state.product.tv_tuner} onClick={()=> this.setState({product:{...this.state.product, tv_tuner:"oui"}})} />
                                    <i className="input-helper"></i>    
                                    Oui
                                </label>
                                <label htmlFor="tv_tunerF" className="radio radio-inline m-r-20">
                                    <input name="tv_tuner" id="tv_tunerF" type="radio" value={this.state.product.tv_tuner} onClick={()=> this.setState({product:{...this.state.product, tv_tuner:"non"}})} />
                                    <i className="input-helper"></i>    
                                    Non
                                </label>

                            </div>
                        </div>
    
                        {/* ADD 
                        
                        * TYPE (LED, ...)
                         */}
                    </div>

                    }
                    {this.state.product.men_type === "Ventilateur" &&
                        <InputText  change={this.handleChange} value={this.state.product.vent_puissance} name="vent_puissance" title="Puissance(W) " required error={this.state.errors.vent_puissance}/>
                        
                    }

                    <GroupCheckbox label="Tension d'alimentation" required error={this.state.errors.bat_tension}>
                        <SingleCheckbox label="12V" value={12} checked={this.state.product.tv_tension_alim && this.state.product.tv_tension_alim.includes(12)} onChange={(e) => this.setCheckbox(e, "tv_tension_alim")} />
                        <SingleCheckbox label="220V" value={220} checked={this.state.product.tv_tension_alim && this.state.product.tv_tension_alim.includes(220)} onChange={(e) => this.setCheckbox(e, "tv_tension_alim")} />
                    </GroupCheckbox>  
                    <TextArea 
                        name="men_infos" 
                        value={this.state.product.men_infos} 
                        error={this.state.errors.men_infos} 
                        change={this.handleChange} 
                        title="Autres informations" 
                        required
                        rows={5}
                        placeholder="Taille, description, couleur... " 
                    />
                    
                </div>
                }
                {this.state.product.product_type === "autres" &&
                    <TextArea 
                        name="desc" 
                        value={this.state.product.desc} 
                        error={this.state.errors.desc} 
                        change={this.handleChange} 
                        title="Description" 
                        required
                        rows={5}
                        placeholder="Taille, description, couleur... " 
                    />
                }
                <Grid container spacing={1}>
                    {/* <Grid item xs={12}>
                        <Typography variant="subtitle1">Dimensions (LxlxH) *</Typography>
                    </Grid> */}
                    <Grid item xs={4}>
                        <InputText
                            change={this.handleChange} 
                            value={this.state.product.largeur} 
                            name="largeur" 
                            title="Largeur (mm)" 
                            required 
                            error={this.state.errors.largeur}
                            type="number"
                        />
                    </Grid>
                    
                    <Grid item xs={4}>
                        <InputText
                            change={this.handleChange} 
                            value={this.state.product.longueur} 
                            name="longueur" 
                            title="Longueur (mm)" 
                            required 
                            error={this.state.errors.longueur}
                            type="number"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputText
                            change={this.handleChange} 
                            value={this.state.product.hauteur} 
                            name="hauteur" 
                            title="Hauteur (mm)" 
                            required 
                            error={this.state.errors.hauteur}
                            type="number"
                        />
                    </Grid>                        
                </Grid>

                <InputText type="number" inputProps={{inputMode: 'numeric',pattern: '[0-9]*',}} name="poids" value={this.state.product.poids} error={this.state.errors.poids}  change={this.handleChange} title="Poids (Kg) " required placeholder="Poids en Kg" />

                <InputText type="number" inputProps={{inputMode: 'numeric',pattern: '[0-9]*',}} change={this.handleChange} value={this.state.product.prix_venteHT} name="prix_venteHT" title="Prix de Vente HT " required error={this.state.errors.prix_venteHT} />

                <div className="row m-5 text-center">
                    <Button color="secondary" onClick={() => this.setState({openPriceList: true})}>Ajouter des Prix</Button>
                </div>
                {openPriceList && 
                    <PriceList 
                        savePriceList={this.savePriceList}
                        handleClose={this.handleClosePriceList}
                        price_list={this.state.product.price_list} 
                        nbLine={size(this.state.product.price_list)} 
                        prix_venteHT={this.state.product.prix_venteHT}
                        prix_venteHT_pro={this.state.product.prix_venteHT_pro}
                    />
                }
                
                <InputText type="number" inputProps={{inputMode: 'numeric',pattern: '[0-9]*',}}change={this.handleChange} value={this.state.product.tva_rate} name="tva_rate" title="Taux TVA (%)  " error={this.state.errors.tva_rate} />

                <InputText 
                    change={this.handleChange} 
                    value={Math.round(this.state.product.prix_venteTTC)} 
                    name="prix_venteTTC" 
                    title="Prix de Vente TTC " required 
                    disabled 
                    error={this.state.errors.prix_venteTTC} 
                />
                                    
                <InputText  type="number" inputProps={{inputMode: 'numeric',pattern: '[0-9]*',}} change={this.handleChange} value={this.state.product.reduc_max} name="reduc_max" title="Reduction Maximale " required error={this.state.errors.reduc_max} />
                                    
            </Box>
        )
        const submit = (
            <Button 
                disabled={this.state.sending || this.props.STATE.products.fetching} 
                className="confirm"
                color="secondary"
                variant="contained"
                // style={{ display: "inline-block" }} 
                onClick={this.handleSubmit}
            >
                Ajouter
            </Button>
        )
        const submitUpdate = (
            <Button 
                disabled={this.state.sending || this.props.STATE.products.fetching}     
                className="confirm"
                color="secondary"
                variant="contained" 
                // style={{ display: "inline-block" }} 
                onClick={this.handleSubmitUpdate}
            >
                {this.props.duplicate ? "Dupliquer" : "Modifier"}
            </Button>
        )
        console.log(this.state.product);
        return (
            <div className="card-text">
                <h3 className="card-title">Nouveau Produit</h3>
                <div>
                    {/* <StockageZone 
                        handleClose={this.props.handleClose}
                    /> */}
                    {prodForm}

                    <Box p={2}>
                        <div className="pull-right">
                            {(this.props.update ? submitUpdate : submit)}
                            <Button 
                                disabled={this.props.STATE.products.fetching} 
                                onClick={() => {
                                    if (this.props.handleCloseForm) {
                                        this.props.handleCloseForm()
                                    } else {
                                        this.props.handleClose()
                                    }
                                }}
                                color="secondary"
                            >
                                Annuler
                            </Button>
                        </div>
                    </Box>
                </div>
            </div>
        );
    }
}

export default FormProduct;